import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from '../../token/interceptor';
import { TipoCaracteristicasBenefService } from '../parametros/tipoCaracteristicasBenef/tipoCaracteristicasBenef.service';
import { TipoProcesoService } from '../parametros/tipoProceso/tipoProceso.service';
import { FlujoTrabajoService } from '../parametros/flujoTrabajo/flujoTrabajo.service';
import { UsuariosFlujoTrabajoService } from '../parametros/usuariosFlujoTrabajo/usuariosFlujoTrabajo.service';
import { TipoEntidadBeneficiariaService } from '../parametros/tipoEntidadBeneficiaria/tipoEntidadBeneficiaria.service';
import { TipoParticipanteService } from '../parametros/tipoParticipante/tipoParticipante.service';
import { TipoPersonaEntidadService } from '../parametros/tipoPersonaEntidad/tipoPersonaEntidad.service';
import { EntidadConvenioService } from '../general/entidadConvenio/entidadConvenio.service';
import { CaracteristicasEntidadBenefService } from '../general/caracteristicasEntidadBenef/caracteristicasEntidadBenef.service';
import { EntidadBeneficiariaService } from '../general/entidadBeneficiaria/entidadBeneficiaria.service';
import { PersonalEntidadBeneficiariaService } from '../general/personalEntidadBeneficiaria/personalEntidadBeneficiaria.service';
import { VwsInformacionGeneralEntidadService } from '../parametros/vwsInformacionGeneralEntidad/vwsInformacionGeneralEntidad.service';
import { SolicitudService } from '../opciones/practicas/solicitud/solicitud/solicitud.service';
import { ActividadesSolicitudService } from '../opciones/practicas/solicitud/actividadesSolicitud/actividadesSolicitud.service';
import { ParticipantesSolicitudService } from '../opciones/practicas/solicitud/participantesSolicitud/participantesSolicitud.service';
import { DelegadoTipoProcesoService } from '../parametros/delegadoTipoProceso/delegadoTipoProceso.service';
import { PropuestaTecnicaConvenioService } from '../opciones/practicas/propuesta_tecnica/propuestaTecnicaConvenio/propuestaTecnicaConvenio.service';
import { FlujoAprobacionPropuestaService } from '../opciones/practicas/flujoAprobacionPropuesta/flujoAprobacionPropuesta.service';
import { NovedadesVinculacionService } from '../general/novedadesVinculacion/novedadesVinculacion.service';
import { AsignaturasRelacionadasService } from '../opciones/practicas/asignaturasRelacionadas/asignaturasRelacionadas.service';
import { TipoDelegadoService } from '../parametros/tipoDelegado/tipoDelegado.service';
import { RegistroTutorSolicitudAprobadaService } from '../opciones/practicas/solicitud/registroTutorSolicitudAprobada/registroTutorSolicitudAprobada.service';
import { TipoProyectosTrabajoService } from '../parametros/tipoProyectosTrabajo/tipoProyectosTrabajo.service';
import { ProyectosService } from '../opciones/proyectos/proyectos.service';
import { ProyectoParticipantesService } from '../opciones/proyectoParticipantes/proyectoParticipantes.service';
import { ProyectoObjetivoService } from '../opciones/proyectoObjetivo/proyectoObjetivo.service';
import { TutoresEntidadBenficiariaService } from '../opciones/tutoresEntidadBenficiaria/tutoresEntidadBenficiaria.service';
import { BitacoraService } from '../opciones/bitacora/bitacora.service';
import { CronogramaActividadesService } from '../opciones/cronogramaActividades/cronogramaActividades.service';
import { CronogramaActividadesParticipantesService } from '../opciones/cronogramaActividadesParticipantes/cronogramaActividadesParticipantes.service';
import { SolicitudPersonaContactoEmpresaService } from '../opciones/solicitudPersonaContactoEmpresa/solicitudPersonaContactoEmpresa.service';
import { RegistroObservacionesBitacoraService } from '../opciones/registroObservacionesBitacora/registroObservacionesBitacora.service';
import { ProyectoInformeFinalService } from '../opciones/proyectoInformeFinal/proyectoInformeFinal.service';
import { EvaluacionCuestionarioService } from '../opciones/evaluacionCuestionario/evaluacionCuestionario.service';
import { EvaluacionParticipanteService } from '../opciones/evaluacionParticipante/evaluacionParticipante.service';
import { EvaluacionPlanParticipanteService } from '../opciones/evaluacionPlanParticipante/evaluacionPlanParticipante.service';
import { RegistroObservacionesActividadesService } from '../opciones/registroObservacionesActividades/registroObservacionesActividades.service';
import { RegistroObservacionesProyectoService } from '../opciones/registroObservacionesProyecto/registroObservacionesProyecto.service';
import { CategoriasInformePlanTrabajoService } from '../parametros/categoriasInformePlanTrabajo/categoriasInformePlanTrabajo.service';
import { RespuestasEvaluacionService } from '../parametros/respuestasEvaluacion/respuestasEvaluacion.service';
import { ProyectoDocumentacionService } from '../opciones/proyectoDocumentacion/proyectoDocumentacion.service';
import { ProyectoTipoDocumentacionService } from '../parametros/proyectoTipoDocumentacion/proyectoTipoDocumentacion.service';
import { RegistroObservacionesDocumentosService } from '../util/registroObservacionesDocumentos/registroObservacionesDocumentos.service';
import { NovedadesProyectoDocumentosService } from '../general/novedadesProyectoDocumentos/novedadesProyectoDocumentos.service';
import { ProyectoMasterService } from '../programas/proyectoMaster/proyectoMaster.service';
import { ProgramasService } from '../programas/programas/programas.service';
import { RegistroHorasTutoriasPeriodoAcademicoService } from '../opciones/registroHorasTutoriasPeriodoAcademico/registroHorasTutoriasPeriodoAcademico.service';
import { ProyectoParticipanteTutorService } from '../opciones/proyectoParticipanteTutor/proyectoParticipanteTutor.service';
import { ConvocatoriaAyudantiasService } from '../ayudantias/convocatorias/convocatoriaAyudantias/convocatoriaAyudantias.service';
import { DetalleConvocatoriaAyudantiasService } from '../ayudantias/convocatorias/detalleConvocatoriaAyudantias/detalleConvocatoriaAyudantias.service';
import { DetalleConvocatoriaPostulacionesService } from '../ayudantias/convocatorias/detalleConvocatoriaPostulaciones/detalleConvocatoriaPostulaciones.service';
import { ConvenioAyudantiasService } from '../ayudantias/convenio/convenioAyudantias/convenioAyudantias.service';
import { DetalleConvocatoriaValidacionPostulacionService } from '../ayudantias/convocatorias/detalleConvocatoriaValidacionPostulacion/detalleConvocatoriaPostulaciones.service';
import { DetalleConvocatoriaAyudantiasAsignaturasService } from '../ayudantias/convocatorias/detalleConvocatoriaAyudantiasAsignaturas/detalleConvocatoriaAyudantiasAsignaturas.service';
import { CatalogoGeneralService } from '../parametros/manager_catalogo/catalogoGeneral/catalogoGeneral.service';
import { CatalogoGeneralDetalleService } from '../parametros/manager_catalogo/catalogoGeneralDetalle/catalogoGeneralDetalle.service';
import { CatalogoGeneralTipoNivelService } from '../parametros/manager_catalogo/catalogoGeneralTipoNivel/catalogoGeneralTipoNivel.service';
import { ActividadesLogroObjetivosService } from '../servicio-comunitario/actividadesLogroObjetivos/actividadesLogroObjetivos.service';
import { ArticulacionAcademicaPertinenciaService } from '../servicio-comunitario/articulacionAcademicaPertinencia/articulacionAcademicaPertinencia.service';
import { EscuelasParticipantesService } from '../servicio-comunitario/escuelasParticipantes/escuelasParticipantes.service';
import { GruposPoblacionBeneficiarioService } from '../servicio-comunitario/gruposPoblacionBeneficiario/gruposPoblacionBeneficiario.service';
import { ProyectoAlcanceTerritorialService } from '../servicio-comunitario/proyectoAlcanceTerritorial/proyectoAlcanceTerritorial.service';
import { ProyectoCatalogoAlineacionService } from '../servicio-comunitario/proyectoCatalogoAlineacion/proyectoCatalogoAlineacion.service';
import { ProyectoDescripcionAlineacionService } from '../servicio-comunitario/proyectoDescripcionAlineacion/proyectoDescripcionAlineacion.service';
import { ProyectoDetalleDescripcionAlineacionService } from '../servicio-comunitario/proyectoDetalleDescripcionAlineacion/proyectoDetalleDescripcionAlineacion.service';
import { ProyectoEscuelasParticipantesService } from '../servicio-comunitario/proyectoEscuelasParticipantes/proyectoEscuelasParticipantes.service';
import { ProyectoMatrizMarcoLogicoService } from '../servicio-comunitario/proyectoMatrizMarcoLogico/proyectoMatrizMarcoLogico.service';
import { ProyectoPresupuestoService } from '../servicio-comunitario/proyectoPresupuesto/proyectoPresupuesto.service';
import { ValidacionResultadosAprendizajeService } from '../servicio-comunitario/validacionResultadosAprendizaje/validacionResultadosAprendizaje.service';
/**************VINCULACION******************/

/********************************************FIN VINCULACIÓN*****************************/

@NgModule({
  imports: [CommonModule],
  declarations: [],
})
export class SharedVinculacionModule {
  static forRoot(): ModuleWithProviders<SharedVinculacionModule> {
    return {
      ngModule: SharedVinculacionModule,
      providers: [
        TipoProcesoService,
        FlujoTrabajoService,
        UsuariosFlujoTrabajoService,
        TipoCaracteristicasBenefService,
        TipoEntidadBeneficiariaService,
        TipoParticipanteService,
        TipoPersonaEntidadService,
        CaracteristicasEntidadBenefService,
        EntidadBeneficiariaService,
        EntidadConvenioService,
        PersonalEntidadBeneficiariaService,
        VwsInformacionGeneralEntidadService,
        SolicitudService,
        ActividadesSolicitudService,
        ParticipantesSolicitudService,
        DelegadoTipoProcesoService,
        NovedadesVinculacionService,
        PropuestaTecnicaConvenioService,
        FlujoAprobacionPropuestaService,
        AsignaturasRelacionadasService,
        TipoDelegadoService,
        RegistroTutorSolicitudAprobadaService,
        TipoProyectosTrabajoService,
        ProyectosService,
        ProyectoParticipantesService,
        ProyectoObjetivoService,
        TutoresEntidadBenficiariaService,
        CronogramaActividadesService,
        CronogramaActividadesParticipantesService,
        BitacoraService,
        SolicitudPersonaContactoEmpresaService,
        RegistroObservacionesBitacoraService,
        ProyectoInformeFinalService,
        EvaluacionCuestionarioService,
        EvaluacionParticipanteService,
        EvaluacionPlanParticipanteService,
        RegistroObservacionesActividadesService,
        RegistroObservacionesProyectoService,
        CategoriasInformePlanTrabajoService,
        RespuestasEvaluacionService,
        ProyectoDocumentacionService,
        ProyectoTipoDocumentacionService,
        RegistroObservacionesDocumentosService,
        NovedadesProyectoDocumentosService,
        ConvocatoriaAyudantiasService,
        DetalleConvocatoriaAyudantiasService,
        DetalleConvocatoriaPostulacionesService,
        ProgramasService,
        ProyectoMasterService,
        RegistroHorasTutoriasPeriodoAcademicoService,
        ProyectoParticipanteTutorService,
        ConvenioAyudantiasService,
        DetalleConvocatoriaValidacionPostulacionService,
        DetalleConvocatoriaAyudantiasAsignaturasService,
        CatalogoGeneralTipoNivelService,
        CatalogoGeneralService,
        CatalogoGeneralDetalleService,
        ValidacionResultadosAprendizajeService,
        ProyectoPresupuestoService,
        ProyectoMatrizMarcoLogicoService,
        ProyectoEscuelasParticipantesService,
        ProyectoDetalleDescripcionAlineacionService,
        ProyectoDescripcionAlineacionService,
        ProyectoCatalogoAlineacionService,
        ProyectoAlcanceTerritorialService,
        GruposPoblacionBeneficiarioService,
        EscuelasParticipantesService,
        ArticulacionAcademicaPertinenciaService,
        ActividadesLogroObjetivosService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true,
        },
      ],
    };
  }
}
